/**
 * Post-login "return to where you were" (`?redirectTo=`), kept open-redirect
 * safe: only a same-origin absolute path is honoured — no scheme, no
 * protocol-relative `//evil`, no backslash tricks — anything else falls back.
 */
export function safeRedirect(to: unknown, fallback: string): string {
  if (typeof to !== 'string' || to.length === 0) return fallback;
  if (!to.startsWith('/') || to.startsWith('//') || to.startsWith('/\\')) return fallback;
  return to;
}

/** Append `redirectTo=<to>` to `path` when `to` is a safe path; otherwise return `path` untouched. */
export function withRedirectTo(path: string, to: unknown): string {
  const safe = safeRedirect(to, '');
  if (!safe) return path;
  return `${path}${path.includes('?') ? '&' : '?'}redirectTo=${encodeURIComponent(safe)}`;
}
